export interface TinkMessageEventRaw {
  origin: string;
  type: string;
  data: string | object;
}

export interface TinkMessageEvent {
  type:
    | 'application-event'
    | 'view-event'
    | 'code'
    | 'error'
    | 'credentials'
    | 'status'
    | 'reports'
    | string;
  data: any;
  error?: any;
}

export const parseTinkMessageEvent = (
  event: TinkMessageEventRaw,
): TinkMessageEvent => {
  const parsed =
    typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
  const { type, data, error } = parsed;
  return { type, data, error };
};
